import { CssBaseline, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/es-mx';
import { Route, Routes } from 'react-router';
import NotificationsArea from './components/ui/NotificationsArea';
import AppRoutes from './routes/AppRoutes';
import PublicRoutes from './routes/PublicRoutes';
import { useAuthStore } from './stores/auth/auth.store';
import theme from './styles/theme';

function App() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es-mx'>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes>
          {isAuthenticated ? (
            <Route path="/*" element={<AppRoutes />} />
          ) : (
            <Route path="/*" element={<PublicRoutes />} />
          )}
        </Routes>
        <NotificationsArea />
      </ThemeProvider>
    </LocalizationProvider>
  );
}

export default App;
